import React from "react";
import { differenceInDays, format, formatDistanceToNowStrict } from "date-fns";

const DORMANT_DAYS = 30;

/** Last sign-in, with dormant accounts called out. */
export function LastSeen({ iso, userId }) {
  if (!iso) {
    return (
      <span className="text-xs text-[#B45309] font-heading font-semibold" data-testid={`user-last-seen-${userId}`}>
        Never signed in
      </span>
    );
  }
  const when = new Date(iso);
  const dormant = differenceInDays(new Date(), when) >= DORMANT_DAYS;
  return (
    <span
      className={`text-xs ${dormant ? "text-[#B45309] font-heading font-semibold" : "text-[#4D4D4D]"}`}
      title={format(when, "PPpp")}
      data-testid={`user-last-seen-${userId}`}
    >
      {formatDistanceToNowStrict(when, { addSuffix: true })}
      {dormant && " · dormant"}
    </span>
  );
}
